const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlatTLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "3828px",
    height: "3828px",
    viewBox: "0 0 3828 3828",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#fefefe",
    d: "M 1895.5,-0.5 C 1907.5,-0.5 1919.5,-0.5 1931.5,-0.5C 2367.66,7.47699 2756.99,144.644 3099.5,411C 3377.71,632.928 3580.21,910.428 3707,1243.5C 3782.83,1448.16 3823,1659.5 3827.5,1877.5C 3827.5,1901.5 3827.5,1925.5 3827.5,1949.5C 3816.08,2375.68 3680.91,2756.68 3422,3092.5C 3220.2,3348.31 2970.04,3541.48 2671.5,3672C 2445.32,3768.71 2209.32,3820.55 1963.5,3827.5C 1930.17,3827.5 1896.83,3827.5 1863.5,3827.5C 1452.72,3813.76 1083.72,3684.26 756.5,3439C 459.895,3211.09 246.062,2921.59 115,2570.5C 42.4283,2369.72 3.92827,2162.72 -0.5,1949.5C -0.5,1925.5 -0.5,1901.5 -0.5,1877.5C 9.42232,1489.25 124.256,1135.92 344,817.5C 562.813,508.707 847.313,282.207 1197.5,138C 1421.64,48.5384 1654.31,2.37172 1895.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfd1d2",
    d: "M 2036.5,106.5 C 2130.39,111.936 2223.39,125.103 2315.5,146C 2405.42,167.031 2493.42,194.197 2579.5,227.5C 2535.23,317.381 2490.39,407.048 2445,496.5C 2308.96,366.296 2172.8,236.296 2036.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9d9fa2",
    d: "M 1780.5,105.5 C 1784.88,105.174 1789.22,105.508 1793.5,106.5C 1653.82,236.684 1513.98,366.684 1374,496.5C 1332.05,407.424 1290.21,318.258 1248.5,229C 1248.64,228.228 1248.98,227.561 1249.5,227C 1420.47,159.949 1597.47,119.449 1780.5,105.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#75777a",
    d: "M 1915.5,121.5 C 1922.94,127.77 1930.28,134.27 1937.5,141C 2082.83,280.333 2228.17,419.667 2373.5,559C 2219.3,623.846 2064.8,688.013 1910,751.5C 1754.61,688.256 1599.44,624.423 1444.5,560C 1601.4,413.6 1758.4,267.433 1915.5,121.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#231f20",
    d: "M 3094.5,539.5 C 3089.69,540.487 3084.69,540.821 3079.5,540.5C 2897.82,537.386 2716.15,533.553 2534.5,529C 2578.54,441.089 2622.71,353.256 2667,265.5C 2822.58,337.474 2965.08,428.807 3094.5,539.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#231f20",
    d: "M 1159.5,265.5 C 1160.5,265.414 1161.33,265.748 1162,266.5C 1203.36,353.897 1244.2,441.564 1284.5,529.5C 1102.83,531.412 921.168,532.912 739.5,534C 866.948,425.722 1006.95,336.222 1159.5,265.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c0c2c4",
    d: "M 3094.5,539.5 C 3095.04,539.56 3095.38,539.893 3095.5,540.5C 3090.01,541.815 3084.68,541.815 3079.5,540.5C 3084.69,540.821 3089.69,540.487 3094.5,539.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9d9fa2",
    d: "M 1226.5,623.5 C 1246.84,623.167 1267.18,623.5 1287.5,624.5C 1223.65,779.53 1159.82,934.53 1096,1089.5C 943.321,1153.26 790.488,1216.59 637.5,1279.5C 632.869,1066.82 628.369,854.157 624,641.5C 627.5,638 631,634.5 634.5,631C 831.995,628.409 1029.33,625.909 1226.5,623.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfd1d2",
    d: "M 2530.5,623.5 C 2751.43,628.159 2972.43,632.659 3193.5,637C 3195.76,637.236 3197.93,637.736 3200,638.5C 3196.67,852.51 3192.51,1066.51 3187.5,1280.5C 3032.58,1216.2 2877.58,1152.2 2722.5,1088.5C 2658.81,933.446 2594.81,778.446 2530.5,623.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e1e2e3",
    d: "M 2430.5,637.5 C 2431.83,637.5 2433.17,637.5 2434.5,637.5C 2487.98,768.469 2542.14,899.136 2597,1029.5C 2598.31,1032.09 2598.98,1034.76 2599,1037.5C 2410.74,958.962 2222.24,880.795 2033.5,803C 2165.83,747.834 2298.17,692.667 2430.5,637.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#231f20",
    d: "M 1383.5,637.5 C 1515.59,693.379 1647.59,749.545 1779.5,806C 1592.98,883.504 1406.48,961.004 1220,1038.5C 1219.68,1036.45 1220.01,1034.45 1221,1032.5C 1275.44,901.02 1329.61,769.353 1383.5,637.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#231f20",
    d: "M 3292.5,740.5 C 3295.72,743.218 3298.89,746.218 3302,749.5C 3405.47,872.978 3491.31,1008.31 3559.5,1155.5C 3467.68,1196.22 3375.68,1236.55 3283.5,1276.5C 3283.17,1268.5 3282.83,1260.5 3282.5,1252.5C 3286.69,1081.85 3290.02,911.183 3292.5,740.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#231f20",
    d: "M 530.5,743.5 C 535.938,920.641 539.771,1097.97 542,1275.5C 454.042,1234.88 366.208,1194.71 278.5,1155C 275.466,1153.61 272.8,1151.78 270.5,1149.5C 339.38,1002.12 426.047,866.786 530.5,743.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#231f20",
    d: "M 2774.5,1211.5 C 2907.18,1266.23 3039.85,1321.06 3172.5,1376C 3118.74,1511.12 3065.07,1646.29 3011.5,1781.5C 2932.11,1591.65 2853.11,1401.65 2774.5,1211.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9d9fa2",
    d: "M 1042.5,1213.5 C 1043.38,1213.37 1044.04,1213.7 1044.5,1214.5C 968.701,1399.43 892.368,1584.09 815.5,1768.5C 761.298,1637.89 707.298,1507.22 653.5,1376.5C 654.779,1374.85 656.445,1373.69 658.5,1373C 786.704,1320.06 914.704,1266.89 1042.5,1213.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcddde",
    d: "M 232.5,1237.5 C 325.755,1279.53 418.755,1322.03 511.5,1365C 376.667,1503.83 241.833,1642.67 107,1781.5C 119.568,1593.24 161.401,1411.91 232.5,1237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcddde",
    d: "M 3595.5,1242.5 C 3596.75,1242.58 3597.58,1243.24 3598,1244.5C 3668.15,1420.21 3709.15,1602.54 3721,1791.5C 3585.32,1649.98 3449.82,1508.32 3314.5,1366.5C 3408.23,1325.15 3501.9,1283.82 3595.5,1242.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfd1d2",
    d: "M 573.5,1435.5 C 574.675,1435.28 575.675,1435.61 576.5,1436.5C 639.168,1588.84 701.835,1741.17 764.5,1893.5C 691.481,2071.73 617.981,2249.73 544,2427.5C 396.638,2277.8 249.638,2127.8 103,1977.5C 101.911,1958.84 101.578,1940.18 102,1921.5C 259.37,1759.63 416.536,1597.63 573.5,1435.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9d9fa2",
    d: "M 3249.5,1436.5 C 3255.41,1440.9 3260.91,1445.9 3266,1451.5C 3418.64,1611.8 3571.64,1771.8 3725,1931.5C 3725.41,1947.18 3725.08,1962.84 3724,1978.5C 3574,2123.83 3424,2269.17 3274,2414.5C 3203.83,2245.49 3133.66,2076.49 3063.5,1907.5C 3125.79,1750.6 3187.79,1593.6 3249.5,1436.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#231f20",
    d: "M 1644.5,1661.5 C 1644.5,1826.83 1644.5,1992.17 1644.5,2157.5C 1601.83,2157.5 1559.17,2157.5 1516.5,2157.5C 1516.5,1992.17 1516.5,1826.83 1516.5,1661.5C 1559.17,1661.5 1601.83,1661.5 1644.5,1661.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7d7f81",
    d: "M 2617.5,1791.5 C 2668.33,1790.5 2719.33,1790.17 2770.5,1790.5C 2770.5,1749.5 2770.5,1708.5 2770.5,1667.5C 2621.17,1667.5 2471.83,1667.5 2322.5,1667.5C 2322.5,1708.5 2322.5,1749.5 2322.5,1790.5C 2294.5,1790.5 2266.5,1790.5 2238.5,1790.5C 2238.5,1790.17 2238.5,1789.83 2238.5,1789.5C 2266.17,1789.5 2293.83,1789.5 2321.5,1789.5C 2321.5,1748.5 2321.5,1707.5 2321.5,1666.5C 2471.5,1666.5 2621.5,1666.5 2771.5,1666.5C 2771.5,1708.17 2771.5,1749.83 2771.5,1791.5C 2720.17,1791.5 2668.83,1791.5 2617.5,1791.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#636466",
    d: "M 2109.5,1672.5 C 2152.33,1671.5 2195.33,1671.17 2238.5,1671.5C 2238.5,1710.83 2238.5,1750.17 2238.5,1789.5C 2238.5,1789.83 2238.5,1790.17 2238.5,1790.5C 2237.5,1751.34 2237.17,1712 2237.5,1672.5C 2194.83,1672.5 2152.17,1672.5 2109.5,1672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#231f20",
    d: "M 2617.5,1791.5 C 2617.5,1913.5 2617.5,2035.5 2617.5,2157.5C 2570.17,2157.5 2522.83,2157.5 2475.5,2157.5C 2475.5,2035.17 2475.5,1912.83 2475.5,1790.5C 2424.66,1790.17 2374,1790.5 2323.5,1791.5C 2323.5,1825.5 2323.5,1859.5 2323.5,1893.5C 2295.17,1893.5 2266.83,1893.5 2238.5,1893.5C 2238.03,1940.53 2238.53,1987.53 2240,2034.5C 2243.26,2044.76 2250.1,2051.26 2260.5,2054C 2282.25,2056.56 2302.75,2052.73 2322,2042.5C 2322.67,2076.17 2322.67,2109.83 2322,2143.5C 2275.74,2166.84 2227.57,2171.68 2177.5,2158C 2146.17,2147.34 2125.67,2126.17 2116,2094.5C 2114.02,2086.56 2112.35,2078.56 2111,2070.5C 2109.58,2011.51 2109.08,1952.51 2109.5,1893.5C 2095.17,1893.5 2080.83,1893.5 2066.5,1893.5C 2066.5,1859.17 2066.5,1824.83 2066.5,1790.5C 2081.01,1790.83 2095.34,1790.5 2109.5,1789.5C 2109.5,1750.5 2109.5,1711.5 2109.5,1672.5C 2152.17,1672.5 2194.83,1672.5 2237.5,1672.5C 2237.17,1712 2237.5,1751.34 2238.5,1790.5C 2266.5,1790.5 2294.5,1790.5 2322.5,1790.5C 2322.5,1749.5 2322.5,1708.5 2322.5,1667.5C 2471.83,1667.5 2621.17,1667.5 2770.5,1667.5C 2770.5,1708.5 2770.5,1749.5 2770.5,1790.5C 2719.33,1790.17 2668.33,1790.5 2617.5,1791.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#999b9e",
    d: "M 1292.5,1682.5 C 1220.5,1682.5 1148.5,1682.5 1076.5,1682.5C 1076.5,1840.83 1076.5,1999.17 1076.5,2157.5C 1120.17,2157.5 1163.83,2157.5 1207.5,2157.5C 1207.83,2157.5 1208.17,2157.5 1208.5,2157.5C 1164.34,2158.5 1120,2158.83 1075.5,2158.5C 1075.5,1999.5 1075.5,1840.5 1075.5,1681.5C 1148,1681.17 1220.34,1681.5 1292.5,1682.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#231f20",
    d: "M 1292.5,1682.5 C 1333.12,1682.99 1371.12,1693.16 1406.5,1713C 1447.98,1739.87 1471.48,1778.03 1477,1827.5C 1483.97,1924.11 1441.14,1985.95 1348.5,2013C 1326.45,2018.26 1304.12,2021.1 1281.5,2021.5C 1256.83,2021.5 1232.17,2021.5 1207.5,2021.5C 1207.5,2066.83 1207.5,2112.17 1207.5,2157.5C 1163.83,2157.5 1120.17,2157.5 1076.5,2157.5C 1076.5,1999.17 1076.5,1840.83 1076.5,1682.5C 1148.5,1682.5 1220.5,1682.5 1292.5,1682.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#231f20",
    d: "M 2042.5,1937.5 C 2042.5,2010.83 2042.5,2084.17 2042.5,2157.5C 2000.5,2157.5 1958.5,2157.5 1916.5,2157.5C 1916.83,2144.82 1916.5,2132.15 1915.5,2119.5C 1914.89,2119.62 1914.56,2119.96 1914.5,2120.5C 1886.08,2150.43 1851.08,2165.43 1809.5,2165.5C 1776.32,2167.22 1746.65,2158.05 1720.5,2138C 1695.96,2115.24 1683.96,2087.07 1684.5,2053.5C 1684.28,1997.75 1710.61,1961.25 1763.5,1944C 1814.24,1931.79 1864.58,1933.29 1914.5,1948.5C 1914.56,1949.04 1914.89,1949.38 1915.5,1949.5C 1916.82,1943.68 1916.82,1938.01 1915.5,1932.5C 1912.47,1909.97 1900.14,1895.13 1878.5,1888C 1872.6,1886.3 1866.6,1884.97 1860.5,1884C 1830.62,1881.91 1801.29,1884.91 1772.5,1893C 1761.7,1896.21 1751.03,1899.71 1740.5,1903.5C 1732.3,1873.01 1723.63,1842.68 1714.5,1812.5C 1733.57,1805.65 1752.9,1799.48 1772.5,1794C 1826.02,1782.19 1879.68,1781.52 1933.5,1792C 2007.15,1812.19 2043.48,1860.69 2042.5,1937.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#939597",
    d: "M 2109.5,1789.5 C 2095.34,1790.5 2081.01,1790.83 2066.5,1790.5C 2066.5,1824.83 2066.5,1859.17 2066.5,1893.5C 2065.5,1859 2065.17,1824.34 2065.5,1789.5C 2080.17,1789.5 2094.83,1789.5 2109.5,1789.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#87898c",
    d: "M 2323.5,1791.5 C 2374,1790.5 2424.66,1790.17 2475.5,1790.5C 2475.5,1912.83 2475.5,2035.17 2475.5,2157.5C 2474.5,2035.67 2474.17,1913.67 2474.5,1791.5C 2424.17,1791.5 2373.83,1791.5 2323.5,1791.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 1281.5,1793.5 C 1300.76,1794.19 1317.59,1800.86 1332,1813.5C 1345.88,1830.52 1350.21,1849.86 1345,1871.5C 1337.69,1894.14 1322.52,1908.64 1299.5,1915C 1292.9,1916.43 1286.23,1917.43 1279.5,1918C 1255.84,1918.5 1232.17,1918.67 1208.5,1918.5C 1208.5,1876.83 1208.5,1835.17 1208.5,1793.5C 1232.83,1793.5 1257.17,1793.5 1281.5,1793.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6e7072",
    d: "M 1281.5,1793.5 C 1257.17,1793.5 1232.83,1793.5 1208.5,1793.5C 1208.5,1835.17 1208.5,1876.83 1208.5,1918.5C 1207.5,1876.67 1207.17,1834.67 1207.5,1792.5C 1232.34,1792.17 1257.01,1792.5 1281.5,1793.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b4b5b7",
    d: "M 1915.5,1932.5 C 1916.82,1938.01 1916.82,1943.68 1915.5,1949.5C 1914.89,1949.38 1914.56,1949.04 1914.5,1948.5C 1915.49,1943.36 1915.82,1938.03 1915.5,1932.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 1854.5,1998.5 C 1875.84,1997.08 1896.5,2000.08 1916.5,2007.5C 1922.43,2035.58 1914.09,2058.08 1891.5,2075C 1875.56,2083.62 1858.56,2086.62 1840.5,2084C 1816.36,2077.22 1805.53,2061.39 1808,2036.5C 1811.38,2020.12 1820.88,2008.95 1836.5,2003C 1842.48,2000.84 1848.48,1999.34 1854.5,1998.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#231f20",
    d: "M 814.5,2018.5 C 816.446,2020.35 817.946,2022.69 819,2025.5C 907.931,2241.46 996.764,2457.46 1085.5,2673.5C 1085.17,2673.83 1084.83,2674.17 1084.5,2674.5C 936.587,2614.03 788.587,2553.86 640.5,2494C 634.348,2491.42 628.348,2488.59 622.5,2485.5C 686.789,2329.93 750.789,2174.26 814.5,2018.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfd1d2",
    d: "M 3012.5,2034.5 C 3014.34,2035.12 3015.5,2036.46 3016,2038.5C 3075.4,2182.21 3134.9,2325.88 3194.5,2469.5C 3193.12,2471.71 3191.12,2473.21 3188.5,2474C 3049.86,2531.05 2911.19,2588.22 2772.5,2645.5C 2771.42,2644.64 2771.25,2643.64 2772,2642.5C 2852.46,2439.92 2932.62,2237.26 3012.5,2034.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6f7072",
    d: "M 1281.5,2021.5 C 1257.34,2022.5 1233.01,2022.83 1208.5,2022.5C 1208.5,2067.5 1208.5,2112.5 1208.5,2157.5C 1208.17,2157.5 1207.83,2157.5 1207.5,2157.5C 1207.5,2112.17 1207.5,2066.83 1207.5,2021.5C 1232.17,2021.5 1256.83,2021.5 1281.5,2021.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#636467",
    d: "M 1914.5,2120.5 C 1914.56,2119.96 1914.89,2119.62 1915.5,2119.5C 1916.5,2132.15 1916.83,2144.82 1916.5,2157.5C 1916.17,2157.5 1915.83,2157.5 1915.5,2157.5C 1915.83,2144.99 1915.5,2132.66 1914.5,2120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#231f20",
    d: "M 3712.5,2120.5 C 3696.11,2278.56 3658.11,2431.39 3598.5,2579C 3512.8,2546.83 3427.47,2513.49 3342.5,2479C 3466.03,2359.63 3589.37,2240.13 3712.5,2120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#231f20",
    d: "M 113.5,2123.5 C 234.118,2246.45 354.785,2369.45 475.5,2492.5C 393.806,2523.62 311.806,2553.95 229.5,2583.5C 171.078,2435.14 132.411,2281.81 113.5,2123.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#afb1b3",
    d: "M 1644.5,1661.5 C 1645.5,1827 1645.83,1992.67 1645.5,2158.5C 1602.33,2158.83 1559.33,2158.5 1516.5,2157.5C 1559.17,2157.5 1601.83,2157.5 1644.5,2157.5C 1644.5,1992.17 1644.5,1826.83 1644.5,1661.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b2b4b6",
    d: "M 2042.5,1937.5 C 2043.5,2011 2043.83,2084.66 2043.5,2158.5C 2000.66,2158.83 1958,2158.5 1915.5,2157.5C 1915.83,2157.5 1916.17,2157.5 1916.5,2157.5C 1958.5,2157.5 2000.5,2157.5 2042.5,2157.5C 2042.5,2084.17 2042.5,2010.83 2042.5,1937.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfd1d2",
    d: "M 3302.5,2565.5 C 3389.24,2598.71 3475.57,2632.71 3561.5,2667.5C 3490.83,2820.17 3401.33,2960.17 3293,3087.5C 3295.75,2913.5 3298.92,2739.5 3302.5,2565.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dbddde",
    d: "M 3206.5,2567.5 C 3207.83,2572.46 3208.49,2577.79 3208.5,2583.5C 3203.91,2786.83 3199.41,2990.16 3195,3193.5C 3176.79,3211.68 3158.29,3229.51 3139.5,3247C 2938.17,3245.14 2736.84,3242.64 2535.5,3239.5C 2598.03,3082.58 2660.36,2925.58 2722.5,2768.5C 2883.99,2701.46 3045.33,2634.46 3206.5,2567.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#231f20",
    d: "M 516.5,2578.5 C 517.786,2591.34 518.952,2604.34 520,2617.5C 529.1,2779.54 538.434,2941.54 548,3103.5C 434.165,2973.12 340.665,2828.96 267.5,2671C 350.472,2639.85 433.472,2609.01 516.5,2578.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#75777a",
    d: "M 612.5,2584.5 C 786.915,2654.87 961.248,2725.54 1135.5,2796.5C 1194.77,2939.38 1253.77,3082.38 1312.5,3225.5C 1110.03,3233.03 907.527,3240.03 705,3246.5C 698.833,3246.33 692.667,3246.17 686.5,3246C 674.333,3234.5 662.167,3223 650,3211.5C 649.667,3208.83 649.333,3206.17 649,3203.5C 636.667,2997.17 624.5,2790.84 612.5,2584.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#231f20",
    d: "M 2599.5,2818.5 C 2600.38,2818.37 2601.04,2818.7 2601.5,2819.5C 2547.35,2954.12 2493.68,3088.95 2440.5,3224C 2434.07,3222.64 2427.74,3220.64 2421.5,3218C 2289.8,3164.15 2158.14,3110.32 2026.5,3056.5C 2217.41,2976.87 2408.41,2897.54 2599.5,2818.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfd1d2",
    d: "M 1258.5,2846.5 C 1431.03,2916.93 1603.7,2987.1 1776.5,3057C 1653.94,3107.91 1531.28,3158.75 1408.5,3209.5C 1357.72,3088.83 1307.72,2967.83 1258.5,2846.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9d9fa2",
    d: "M 1900.5,3107.5 C 2059.15,3172.16 2217.82,3236.83 2376.5,3301.5C 2223.82,3433.51 2070.82,3565.18 1917.5,3696.5C 1767.84,3560.17 1618.51,3423.51 1469.5,3286.5C 1613.34,3227.01 1757,3167.34 1900.5,3107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9d9fa2",
    d: "M 1308.5,3320.5 C 1309.1,3320.74 1309.43,3321.24 1309.5,3322C 1273.82,3408.22 1237.49,3494.06 1200.5,3579.5C 1054.4,3516.51 919.405,3436.18 795.5,3338.5C 966.656,3332.43 1137.66,3326.43 1308.5,3320.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#848689",
    d: "M 2574.5,3335.5 C 2560.66,3335.17 2546.99,3335.5 2533.5,3336.5C 2532.96,3336.44 2532.62,3336.11 2532.5,3335.5C 2546.66,3334.17 2560.66,3334.17 2574.5,3335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#231f20",
    d: "M 2574.5,3335.5 C 2725.86,3336.42 2877.19,3338.25 3028.5,3341C 2903.23,3439.52 2766.57,3520.02 2618.5,3582.5C 2615.54,3576.81 2613.04,3570.81 2611,3564.5C 2585.26,3488.43 2559.42,3412.43 2533.5,3336.5C 2546.99,3335.5 2560.66,3335.17 2574.5,3335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#231f20",
    d: "M 1804.5,3720.5 C 1802.39,3721.47 1800.06,3721.8 1797.5,3721.5C 1623.14,3710.72 1454.14,3675.22 1290.5,3615C 1289.98,3614.44 1289.64,3613.77 1289.5,3613C 1326.25,3525.68 1363.08,3438.52 1400,3351.5C 1535,3474.34 1669.84,3597.34 1804.5,3720.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#231f20",
    d: "M 2528.5,3615.5 C 2528.44,3616.61 2528.11,3617.61 2527.5,3618.5C 2367.66,3675.77 2202.99,3709.94 2033.5,3721C 2170.33,3603.5 2307.17,3486 2444,3368.5C 2472.62,3450.66 2500.79,3532.99 2528.5,3615.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868789",
    d: "M 2528.5,3615.5 C 2529.89,3616.95 2529.55,3617.95 2527.5,3618.5C 2528.11,3617.61 2528.44,3616.61 2528.5,3615.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c7d80",
    d: "M 1804.5,3720.5 C 1805.04,3720.56 1805.38,3720.89 1805.5,3721.5C 1802.69,3722.8 1800.02,3722.8 1797.5,3721.5C 1800.06,3721.8 1802.39,3721.47 1804.5,3720.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatTLogo);
export default __webpack_public_path__ + "static/media/PlatTLogo.778f9ee9e767457aef10b65827e86cb2.svg";
export { ForwardRef as ReactComponent };